const SoldGiftVoucherRedeemableStatus = Object.freeze({
    EXPIRED: 'Expired',
    REDEEMABLE: 'Redeemable',
    REDEEMED: 'Redeemed',
    UNSUPPORTED: 'Unsupported',
    INACTIVE: 'Inactive',
    VOUCHER_DELETED: 'Voucher Deleted',
});

module.exports = SoldGiftVoucherRedeemableStatus;
